"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var classnames_1 = __importDefault(require("classnames"));
var Icon_1 = __importDefault(require("../../../Icon"));
var consts_1 = require("../../consts");
var hooks_1 = require("../../hooks");
var styles_1 = require("./styles");
var UserAccount = function (_a) {
    var isSubmenuActive = _a.isSubmenuActive, fullName = _a.fullName, email = _a.email, profileImageUrl = _a.profileImageUrl;
    var isSidebarOpen = (0, hooks_1.useSidebarState)().isSidebarOpen;
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(styles_1.UserIconContainer, __assign({ "data-testid": consts_1.TEST_ID_USER_MENU_OPENER, hasImage: !!profileImageUrl }, { children: profileImageUrl ? ((0, jsx_runtime_1.jsx)(styles_1.ProfileImage, { src: profileImageUrl, alt: fullName })) : ((0, jsx_runtime_1.jsx)(Icon_1.default, { name: "account-outline", size: "m" })) })), (0, jsx_runtime_1.jsxs)(styles_1.UserDetails, __assign({ className: (0, classnames_1.default)({ open: isSidebarOpen }) }, { children: [(0, jsx_runtime_1.jsx)(styles_1.UserName, __assign({ className: (0, classnames_1.default)({ fontbold: isSubmenuActive }) }, { children: fullName })), (0, jsx_runtime_1.jsx)(styles_1.Email, { children: email })] }))] }));
};
exports.default = UserAccount;
